module.exports = __webpack_public_path__ + "img/subscript.8d0b080a.svg";